import React from 'react';

const SmsConfigContent = ({
    body = '',
    onChange,
    bodyRef,
    onFocusField,
    onInsertVariable,
}) => {
    // Calculate SMS segment info
    const charCount = (body || '').length;
    const segmentCount = charCount <= 160 ? 1 : Math.ceil(charCount / 153);

    return (
        <>
            <div>
                <label className="block text-[10px] font-bold text-stone-400 uppercase tracking-wider mb-3">Variables (Click to Insert)</label>
                <div className="flex flex-wrap gap-2">
                    <button onClick={() => onInsertVariable && onInsertVariable('{{MyName}}')} className="px-2 py-1.5 bg-stone-100 rounded text-[10px] text-stone-600 border border-stone-200">{'{{MyName}}'}</button>
                    <button onClick={() => onInsertVariable && onInsertVariable('{{FirstName}}')} className="px-2 py-1.5 bg-stone-100 rounded text-[10px] text-stone-600 border border-stone-200">{'{{FirstName}}'}</button>
                    <button onClick={() => onInsertVariable && onInsertVariable('{{LastName}}')} className="px-2 py-1.5 bg-stone-100 rounded text-[10px] text-stone-600 border border-stone-200">{'{{LastName}}'}</button>
                    <button onClick={() => onInsertVariable && onInsertVariable('{{FullName}}')} className="px-2 py-1.5 bg-stone-100 rounded text-[10px] text-stone-600 border border-stone-200">{'{{FullName}}'}</button>
                    <button onClick={() => onInsertVariable && onInsertVariable('{{InterestedProperty}}')} className="px-2 py-1.5 bg-stone-100 rounded text-[10px] text-stone-600 border border-stone-200">{'{{InterestedProperty}'}</button>
                    <button onClick={() => onInsertVariable && onInsertVariable('{{MyPhone}}')} className="px-2 py-1.5 bg-stone-100 rounded text-[10px] text-stone-600 border border-stone-200">{'{{MyPhone}}'}</button>
                </div>
            </div>
            <div>
                <label className="block text-[10px] font-bold text-stone-400 uppercase tracking-wider mb-2">Message</label>
                <textarea
                    ref={bodyRef}
                    onFocus={() => onFocusField && onFocusField('body')}
                    className="w-full h-32 bg-white border border-notion-border rounded-lg p-3 text-sm text-stone-700 outline-none resize-none"
                    value={body}
                    onChange={(e) => onChange && onChange({ body: e.target.value })}
                    placeholder="Hi {{First Name}}, thanks for coming to the open house at {{Interest Address}}. Do you have any questions about the property? - {{Agent Name}}"
                />
                <div className="flex justify-between items-center mt-2">
                    <span className="text-[10px] text-stone-400">{segmentCount} segment{segmentCount !== 1 ? 's' : ''} ({charCount} chars)</span>
                </div>
            </div>
        </>
    );
};

export default SmsConfigContent;
